module.exports = __webpack_public_path__ + "fca035a90399f89dea7deb1872f3e9ae.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/empty-table.png
// module id = 3150
// module chunks = 0